<template>
  <div class="dashboard-page dark-theme">
    <!-- 顶部公告栏 -->
    <div class="announcement-banner" v-if="notices && notices.length > 0">
      <div class="announcement-inner">
        <a-icon type="bulb" class="announcement-icon" />
        <div class="announcement-text" :key="currentNoticeIndex">
          {{ notices[currentNoticeIndex].message }}
        </div>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="dashboard-container">
      <!-- 流量概览卡片 -->
      <div class="overview-card">
        <div class="overview-header">
          <h2 class="overview-title">{{ translate('database.header.contant1') }}</h2>
        </div>
        <div class="overview-stats">
          <div class="stat-item">
            <div class="stat-label">{{ translate('database.header.contant1') }}</div>
            <div class="stat-value">{{ flowoverdue }}GB</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <div class="stat-label">{{ translate('database.header.contant2') }}</div>
            <div class="stat-value">{{ flow }}GB</div>
          </div>
        </div>
        <div class="overview-progress">
          <a-progress 
            :percent="parseFloat(flowoverdue && flow ? (flowoverdue / flow * 100).toFixed(1) : 0)" 
            :stroke-width="12" 
            :stroke-color="{ '0%': '#1581c6', '100%': '#1581c6' }"
            :trail-color="'rgba(255, 255, 255, 0.1)'"
            :format="() => ''"
          />
        </div>
      </div>

      <!-- 标签页切换 -->
      <a-tabs v-model="value" @change="changeTabs" class="modern-tabs">
        <a-tab-pane :tab="translate('database.tab.title1')" key="dtzz">
          <div class="tab-content">
            <!-- 左侧：代理信息 -->
            <div class="info-section">
              <div class="section-card proxy-info-card">
                <div class="card-header">
                  <a-icon type="info-circle" class="card-icon" />
                  <h3 class="card-title">{{ translate('database.tab.title1') }}</h3>
                </div>
                <div class="proxy-details">
                  <div class="detail-item">
                    <div class="detail-label">{{ translate('database.banner.contant1') }}</div>
                    <div class="detail-content">
                      <a-select 
                        v-model="hostValue" 
                        class="host-select" 
                        style="width: 100%; margin-bottom: 8px;"
                        @change="handleHostChange"
                      >
                        <a-select-option :value="formData.host" :key="formData.host">{{ formData.host }}</a-select-option>
                        <a-select-option value="us.ipipbright.net" key="us.ipipbright.net">us.ipipbright.net</a-select-option>
                        <a-select-option value="eu.ipipbright.net" key="eu.ipipbright.net">eu.ipipbright.net</a-select-option>
                      </a-select>
                      <a-icon type="copy" class="copy-icon" @click="copy" id="equSN" :data-clipboard-text="formData.host" />
                    </div>
                    <a-alert
                      :message="translate('database.banner.contant5')"
                      type="info"
                      class="detail-alert"
                    />
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">{{ translate('database.banner.contant2') }}</div>
                    <div class="detail-content">
                      <span class="detail-value">{{ formData.port }}</span>
                      <a-icon type="copy" class="copy-icon" @click="copy" id="equSN" :data-clipboard-text="formData.port" />
                    </div>
                    <a-alert
                      :message="translate('database.banner.contant6')"
                      type="info"
                      class="detail-alert"
                    />
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">{{ translate('database.banner.contant3') }}</div>
                    <div class="detail-content">
                      <span class="detail-value">{{ formData.username }}</span>
                      <a-icon type="copy" class="copy-icon" @click="copy" id="equSN" :data-clipboard-text="formData.username" />
                    </div>
                    <a-alert
                      :message="translate('database.banner.contant7')"
                      type="info"
                      class="detail-alert"
                    />
                  </div>

                  <div class="detail-item">
                    <div class="detail-label">{{ translate('database.banner.contant4') }}</div>
                    <div class="detail-content password-content">
                      <span class="detail-value">{{ formData.password }}</span>
                      <div>
                        <a-button type="primary" style="margin-right: 8px;" @click="changeAuthPassword" class="reset-btn">
                          {{ translate('resetPassword') }}
                        </a-button>
                        <a-icon type="copy" class="copy-icon" @click="copy" id="equSN" :data-clipboard-text="formData.password" />
                      </div>
                    </div>
                    <a-alert
                      :message="translate('database.banner.contant8')"
                      type="info"
                      class="detail-alert"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- 右侧：代理生成 -->
            <div class="generator-section">
              <div class="section-card generator-card">
                <div class="card-header">
                  <a-icon type="code" class="card-icon" />
                  <h3 class="card-title">{{ translate('database.banner.contant17') }}</h3>
                </div>

                <div class="generator-config">
                  <div class="config-grid">
                    <div class="config-group">
                      <div class="config-item">
                        <span class="config-label">{{ translate('database.header.contant3') }}</span>
                        <a-select :placeholder="translate('database.header.contant3')" v-model="country" @change="changeCode" show-search optionFilterProp="children">
                          <template v-if="currentLanguage === 'en'">
                            <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesEn }}</a-select-option>
                          </template>
                          <template v-else-if="currentLanguage === 'zh'">
                            <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesCn }}</a-select-option>
                          </template>
                        </a-select>
                      </div>

                      <div class="config-item">
                        <span class="config-label">{{ translate('database.header.contant4') }}</span>
                        <a-select :placeholder="translate('database.header.contant4')" v-model="state" @change="changeState">
                          <a-select-option v-for="item in AreaList" :value="item.region" :key="item.region">{{ currentLanguage === 'zh' ? item.region : item.region }}</a-select-option>
                        </a-select>
                      </div>
                    </div>

                    <div class="config-group">
                      <div class="config-item">
                        <span class="config-label">{{ translate('database.header.contant5') }}</span>
                        <a-select :placeholder="translate('database.header.contant5')" v-model="citycode" @change="changeCity">
                          <a-select-option v-for="item in CityList" :value="item.city" :key="item.city">{{ currentLanguage === 'zh' ? item.city : item.city }}</a-select-option>
                        </a-select>
                      </div>

                      <div class="config-item">
                        <span class="config-label">{{ translate('database.header.contant6') }}</span>
                        <a-select :placeholder="translate('database.header.contant6')" v-model="sonAccount" @change="changeSon">
                          <a-select-option v-for="item in sonlist" :value="item.username" :key="item.username">{{ item.username }}</a-select-option>
                        </a-select>
                      </div>
                    </div>

                    <div class="config-group">
                      <div class="config-item">
                        <span class="config-label">{{ translate('database.banner.contant9') }}</span>
                        <a-select :placeholder="translate('database.banner.contant9')" default-value="10" @change="changeLength">
                          <a-select-option v-for="item in proxyListLength" :value="item.value" :key="item.value">{{ item.value }}</a-select-option>
                        </a-select>
                      </div>

                      <div class="config-item">
                        <span class="config-label">{{ translate('database.banner.contant10') }}</span>
                        <a-select :placeholder="translate('database.banner.contant10')" default-value="5" @change="changeTime">
                          <a-select-option v-for="item in proxyTimeList" :value="item.value" :key="item.value">{{ item.value }}</a-select-option>
                        </a-select>
                      </div>
                    </div>

                    <div class="config-group">
                      <div class="config-item">
                        <span class="config-label">{{ translate('database.banner.contant11') }}</span>
                        <a-select :placeholder="translate('database.banner.contant12')" @change="changeProxy">
                          <a-select-option v-for="item in FormatList" :value="item.dictValue" :key="item.dictCode">{{ item.dictValue }}</a-select-option>
                        </a-select>
                      </div>

                      <div class="config-item">
                        <span class="config-label">{{ translate('database.banner.contant13') }}</span>
                        <a-select :placeholder="translate('database.banner.contant12')" @change="changeTimes">
                          <a-select-option :label="translate('database.banner.contant14')" value="0" :key="0">{{ translate('database.banner.contant14') }}</a-select-option>
                          <a-select-option :label="translate('database.banner.contant15')" value="1" :key="1">{{ translate('database.banner.contant15') }}</a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>

                  <div class="generator-actions">
                    <a-button type="primary" @click="getProxyList" class="generate-button">
                      {{ translate('database.banner.contant17') }}
                    </a-button>
                    <div class="secondary-actions">
                      <a-button @click="downloadTxt" icon="download" class="action-btn">
                        {{ translate('database.banner.contant16') || '下载' }}
                      </a-button>
                      <a-button @click="copy" id="equSN" :data-clipboard-text="this.ProxyContant" icon="copy" class="action-btn">
                        {{ translate('database.banner.contant18') || '复制' }}
                      </a-button>
                    </div>
                  </div>

                  <a-textarea 
                    v-model="this.ProxyContant" 
                    read-only 
                    :auto-size="{ minRows: 10, maxRows: 20 }" 
                    class="proxy-result"
                    :placeholder="translate('database.banner.contant17') + ' ' + translate('database.banner.contant12') + '...'"
                  />
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
        
        <!-- <a-tab-pane :tab="translate('database.tab.title2')" key="jtzz">
          <div class="static-proxy-section">
            <div class="section-card static-card">
              <div class="card-header">
                <a-icon type="table" class="card-icon" />
                <h3 class="card-title">{{ translate('database.tab.title2') }}</h3>
              </div>
              
              <div class="static-filter">
                <a-select :placeholder="translate('database.tab2.contant1')" @change="changeCodejt" show-search style="width: 250px; margin-right: 16px;">
                  <template v-if="currentLanguage === 'en'">
                    <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesEn }}</a-select-option>
                  </template>
                  <template v-else-if="currentLanguage === 'zh'">
                    <a-select-option v-for="item in IsoCodeList" :value="item.iso" :key="item.iso">{{ item.countriesCn }}</a-select-option>
                  </template>
                </a-select>
                <a-select placeholder="socks5" default-value="socks5" style="width: 150px;">
                  <a-select-option value="socks5" :key="0">socks5</a-select-option>
                  <a-select-option value="http" :key="1" disabled>http</a-select-option>
                </a-select>
              </div>
              
              <a-table
                  :columns="columns"
                  :data-source="dataList"
                  :loading="dataLoading"
                  :rowKey="rowKey"
                  :pagination="pagination"
                  :scroll="{ x: 1200 }"
                  class="static-table"
                >
                </a-table>
            </div>
          </div>
        </a-tab-pane> -->
      </a-tabs>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { saveAs } from 'file-saver';

export default {
  name: 'DynamicResidence',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'en';
    },
    t() {
      const lang = this.currentLanguage;
      return {
        tabTitle1: lang === 'zh' ? '动态住宅' : 'Dynamic Residential',
        tabTitle2: lang === 'zh' ? '静态住宅' : 'Static dwellings',
        headerContant1: lang === 'zh' ? '剩余动态 residences:' : 'Remaining Dynamic Residences:',
        headerContant2: lang === 'zh' ? '总带宽:' : 'Total bandwidth:',
        headerContant3: lang === 'zh' ? '请选择国家' : 'Please select a country',
        headerContant4: lang === 'zh' ? '请选择地区' : 'Please select a region',
        headerContant5: lang === 'zh' ? '请选择城市' : 'Please select a city',
        headerContant6: lang === 'zh' ? '选择子账户' : 'Select the sub-account',
        headerContant7: lang === 'zh' ? '选择协议' : 'Select the protocol',
        bannerContant1: lang === 'zh' ? '主机' : 'host',
        bannerContant2: lang === 'zh' ? '端口' : 'port',
        bannerContant3: lang === 'zh' ? '用户名' : 'Username',
        bannerContant4: lang === 'zh' ? '密码' : 'password',
        bannerContant5: lang === 'zh' ? '将其放入您的IP/托管设置' : 'Put it into your IP/hosting settings',
        bannerContant6: lang === 'zh' ? '使用指定的端口。每个端口是一个独立的粘性会话，最大长度为120分钟' : 'Use the specified port. Each port is a separate sticky session with a maximum length of 120 minutes',
        bannerContant7: lang === 'zh' ? '您的用户名，对于住宅代理，您会注意到在使用上面的定位选项时用户名会动态变化' : 'Your username, for residential proxies, you will notice that the username changes dynamically when you use the targeting options above',
        bannerContant8: lang === 'zh' ? '您的密码' : 'Your password',
        bannerContant9: lang === 'zh' ? '代理列表长度:' : 'The length of the proxy list:',
        bannerContant10: lang === 'zh' ? '代理时间(分钟):' : 'Agency Time (min):',
        bannerContant11: lang === 'zh' ? '代理链接格式:' : 'Proxy link format:',
        bannerContant12: lang === 'zh' ? '请选择' : 'Please select',
        bannerContant13: lang === 'zh' ? '时间模式:' : 'Timeframe mode:',
        bannerContant14: lang === 'zh' ? '定期更换' : 'Replace it regularly',
        bannerContant15: lang === 'zh' ? '一次换一个' : 'One change at a time',
        bannerContant17: lang === 'zh' ? '生成' : 'Generate',
        tab2Contant1: lang === 'zh' ? '请选择国家' : 'Please select a country',
        tab2Contant2: lang === 'zh' ? '主机' : 'host',
        tab2Contant3: lang === 'zh' ? '端口' : 'port',
        tab2Contant4: lang === 'zh' ? '用户名' : 'Username',
        tab2Contant5: lang === 'zh' ? '密码' : 'password',
        tab2Contant6: lang === 'zh' ? 'IP属性' : 'IP attribution',
        tab2Contant7: lang === 'zh' ? '生效时间' : 'Effective time',
        tab2Contant8: lang === 'zh' ? '到期时间' : 'Expiration time',
        resetPassword: lang === 'zh' ? '重置密码' : 'Reset password',
      };
    },
    columns() {
      return [
        {
          title: this.t.tab2Contant2,
          fixed: 'left',
          width: 200,
          align: 'left',
          ellipsis: true,
          dataIndex: 'uid',
          key: 'uid',
        },
        {
          title: this.t.tab2Contant3,
          width: 200,
          ellipsis: true,
          dataIndex: 'creatTime',
          key: 'creatTime',
        },
        {
          title: this.t.tab2Contant4,
          width: 200,
          ellipsis: true,
          dataIndex: 'flow',
          key: 'flow',
        },
        {
          title: this.t.tab2Contant5,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue1',
          key: 'flowOverdue1',
        },
        {
          title: this.t.tab2Contant6,
          width: 200,
          ellipsis: true,
          dataIndex: 'ipArea',
          key: 'ipArea',
        },
        {
          title: this.t.tab2Contant7,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue2',
          key: 'flowOverdue2',
        },
        {
          title: this.t.tab2Contant8,
          width: 200,
          ellipsis: true,
          dataIndex: 'flowOverdue3',
          key: 'flowOverdue3',
        },
      ];
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      uid: localStorage.getItem("userId"),
      value: 'dtzz',
      StateName:'',
      CityName:'',
      formData:{
        host:'',
        port:'',
        username:'',
        password:'',
      },
      formatid:'',
      life:5,
      listnum:10,
      proxyType:'socks5',
      citycode:undefined,
      state:undefined,
      dyType:'',
      country:'US',
      selectedMode:0,
      
      rowKey: 'index',
      dataLoading: false,
      tableLayout: 'auto',
      verticalAlign: 'top',
      bordered: true,
      hover: true,
      pagination: {
        defaultPageSize: 10,
        total: 0,
        defaultCurrent: 1,
      },
      dataList:[],
      IsoCodeList:[],
      FormatList:[],
      AreaList:[],
      CityList:[],
      sonlist:[],
      sonAccount:undefined,
      ProxyContant:'',
      flow:'',
      flowoverdue:'',
      proxyListLength :[
        { value: 10 },
        { value: 20 },
        { value: 30 },
        { value: 40 },
        { value: 50 },
        { value: 100 },
        { value: 500 },
        { value: 1000 }
      ],
      proxyTimeList:[],
      timer:null,
      noticeTimer:null,
      notices: [],
      currentNoticeIndex: 0,
      hostValue: 'sp.ipipbright.net',
    };
  },
  mounted(){
    for(let i = 1; i <= 120; i++) {
      this.proxyTimeList.push({ value: i });
    }
    
    this.getIsoCodeList();
    this.getProxyflow();
    this.getFormatList();
    this.getProxyList();
    this.getSonAccountList();
    this.start();
    this.getNoticeList();
  },
  updated(){
    if(this.notices.length > 1 && !this.noticeTimer){
      this.startNoticeTimer();
    }
  },
  methods:{
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'database.tab.title1': lang === 'zh' ? '动态住宅' : 'Dynamic Residential',
        'database.tab.title2': lang === 'zh' ? '静态住宅' : 'Static dwellings',
        'database.header.contant1': lang === 'zh' ? '剩余动态住宅:' : 'Remaining Dynamic Residences:',
        'database.header.contant2': lang === 'zh' ? '总带宽:' : 'Total bandwidth:',
        'database.header.contant3': lang === 'zh' ? '请选择国家' : 'Please select a country',
        'database.header.contant4': lang === 'zh' ? '请选择地区' : 'Please select a region',
        'database.header.contant5': lang === 'zh' ? '请选择城市' : 'Please select a city',
        'database.header.contant6': lang === 'zh' ? '选择子账户' : 'Select the sub-account',
        'database.header.contant7': lang === 'zh' ? '选择协议' : 'Select the protocol',
        'database.banner.contant1': lang === 'zh' ? '主机' : 'host',
        'database.banner.contant2': lang === 'zh' ? '端口' : 'port',
        'database.banner.contant3': lang === 'zh' ? '用户名' : 'Username',
        'database.banner.contant4': lang === 'zh' ? '密码' : 'password',
        'database.banner.contant5': lang === 'zh' ? '将其放入您的IP/托管设置' : 'Put it into your IP/hosting settings',
        'database.banner.contant6': lang === 'zh' ? '使用指定的端口。每个端口是一个独立的粘性会话，最大长度为120分钟' : 'Use the specified port. Each port is a separate sticky session with a maximum length of 120 minutes',
        'database.banner.contant7': lang === 'zh' ? '您的用户名，对于住宅代理，您会注意到在使用上面的定位选项时用户名会动态变化' : 'Your username, for residential proxies, you will notice that the username changes dynamically when you use the targeting options above',
        'database.banner.contant8': lang === 'zh' ? '您的密码' : 'Your password',
        'database.banner.contant9': lang === 'zh' ? '代理列表长度:' : 'The length of the proxy list:',
        'database.banner.contant10': lang === 'zh' ? '代理时间(分钟):' : 'Agency Time (min):',
        'database.banner.contant11': lang === 'zh' ? '代理链接格式:' : 'Proxy link format:',
        'database.banner.contant12': lang === 'zh' ? '请选择' : 'Please select',
        'database.banner.contant13': lang === 'zh' ? '时间模式:' : 'Timeframe mode:',
        'database.banner.contant14': lang === 'zh' ? '定期更换' : 'Replace it regularly',
        'database.banner.contant15': lang === 'zh' ? '一次一换' : 'One change at a time',
        'database.banner.contant16': lang === 'zh' ? '下载' : 'Download',
        'database.banner.contant17': lang === 'zh' ? '生成' : 'Generate',
        'database.banner.contant18': lang === 'zh' ? '复制' : 'Copy',
        'database.tab2.contant1': lang === 'zh' ? '请选择国家' : 'Please select a country',
        'database.tab2.contant2': lang === 'zh' ? '主机' : 'host',
        'database.tab2.contant3': lang === 'zh' ? '端口' : 'port',
        'database.tab2.contant4': lang === 'zh' ? '用户名' : 'Username',
        'database.tab2.contant5': lang === 'zh' ? '密码' : 'password',
        'database.tab2.contant6': lang === 'zh' ? 'IP属性' : 'IP attribution',
        'database.tab2.contant7': lang === 'zh' ? '生效时间' : 'Effective time',
        'database.tab2.contant8': lang === 'zh' ? '到期时间' : 'Expiration time',
        'resetPassword': lang === 'zh' ? '重置密码' : 'Reset password',
      };
      return translations[key] || key;
    },
    getNoticeList(){
      this.$request.get('/ums/user/getNoticeList',{
        params: {
          dataType: 'ipipbright'
        }
      }).then((res) => {
        if (res.data.code === 200) {
          this.notices = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    getLoginStatus(){
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear();
          this.$message.warning('请重新登录！');
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    start(){
      this.timer = setInterval(this.getLoginStatus, 10000);
    },
    startNoticeTimer(){
      this.noticeTimer = setInterval(() => {
        this.currentNoticeIndex = (this.currentNoticeIndex + 1) % this.notices.length;
      }, 2000);
    },
    getProxyStaticList() {
      this.$request.post('/consum/getProxyStaticList',
        {
          packageType:this.value,
          uid:this.uid,
          city:this.citycode,
          country:this.country,
          formatid:this.formatid,
          life:this.life,
          listnum:this.listnum,
          proxyType:this.proxyType,
          state:this.state,
          selectedMode:this.selectedMode,

        }
      ).then((res) => {
        if (res.data.code === 200) {
          this.dataList = res.data.data;
        }else{
          this.$message.warning(res.data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    changeCodejt(){
      this.getProxyStaticList()
    },
    changeTabs(){
      if(this.value == 'jtzz'){
        this.getProxyStaticList();
      }else{
        console.log('aaa');
      }
    },
    getIsoCodeList() {
      this.$request.get('/consum/getIsoCodeList').then((res) => {
        if (res.data.code === 200) {
          this.IsoCodeList = res.data.data
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    getFormatList() {
      this.$request.get('/consum/getFormatList').then((res) => {
        if (res.data.code === 200) {
          this.FormatList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    getSonAccountList() {
      this.$request.get('/ums/Pro/selectSonAccount?id='+ this.uid).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
    },
    changeCode(e){
      this.StateName = "";
      this.AreaList = [];
      this.CityName = "";
      this.CityList = [];
      this.citycode = null;
      this.state = null;
      this.country = e;
      if(this.dyType === "ipidea" || this.dyType === "ipidea2" || this.dyType === "ipidea3"){
        this.getAreaflow();
      }
      if(this.dyType === "ipidea3"){
        this.getAreaflow();
      }
      if(this.dyType === "ipipgo" || this.dyType === "testipipgo"){
        this.getAreaflow();
      }
      if(this.dyType === "iproyal"){
        this.getCityflow();
      }
      if(this.dyType === "smart" || this.dyType === "testsmart"){
        this.getCityflow();
      }
      this.getCityflow();
      this.getAreaflow();
      this.getProxyList();
    },
    changeState(e){
      this.CityName = "";
      this.state = e;
      this.citycode = null;
      this.getProxyList();
    },
    changeCity(e){
      this.state = "";
      this.StateName = "";
      this.citycode = e;
      this.getProxyList();
    },
    changeSon(e){
      this.sonAccount = e;
      this.getProxyList();
      this.$request.get('/ums/Pro/selectSonAccount?id='+ this.uid).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data;
          this.sonlist.forEach((item)=>{
            if(e == item.username){
              this.formData.username = item.username;
              this.formData.host = item.ip;
              this.formData.port = item.port;
              this.formData.password = item.password;
            }
          })
        }
      }).catch((e) => {  console.log(e);})
    },
    changeProxy(e){
      this.FormatList.forEach((item)=>{
        if(e == item.dictValue){
          this.formatid = item.dictCode;
        }
      })
      this.getProxyList();
    },
    changeTimes(e){
      if(e == 1){
        this.selectedMode = 1;
      }else if(e == 0){
        this.selectedMode = 0;
      }
      this.getProxyList();
    },
    changeLength(e){
      this.listnum = e;
      this.getProxyList();
    },
    changeTime(e){
      this.life = e;
      this.getProxyList();
    },
    getAreaflow() {
      this.$request.post('/consum/getStatuList',{datatype:this.dyType,country:this.country}).then((res) => {
        if (res.data.code === 200) {
          this.AreaList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    getCityflow() {
      this.$request.post('/consum/getReginlinkList',{datatype:this.dyType,country:this.country,state:this.state}).then((res) => {
        if (res.data.code === 200) {
          this.CityList = res.data.data;
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    getProxyflow() {
      this.$request.post('/consum/getProxyflow',{packageType:this.value,uid:this.uid}).then((res) => {
        console.log(this.formData);
        if (res.data.code === 200) {
          this.flow = res.data.data.flow;
          this.dyType = res.data.data.datatype;
          this.flowoverdue = Number(res.data.data.flow) - Number(res.data.data.flowoverdue);
          this.formData = {...res.data.data}
          this.getCityflow();
          this.getAreaflow();
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    changeAuthPassword(){
      let changeAccount = this.sonlist.filter((item)=>{
        return item.type == "master"
      })
      console.log('this.sonlist', changeAccount[0]);
      this.$request.post('/ums/updateAuthPassword',{
        nodeId: changeAccount[0].nodeId,
        password:changeAccount[0].password
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getProxyflow();
          this.getFormatList();
          this.getProxyList();
        }
      })
    },
    handleHostChange(e){
      this.hostValue = e;
      this.getProxyList();
    },
    getProxyList() {
      this.$request.post('/consum/getProxyListPro',
        {
          packageType:this.value,
          uid:this.uid,
          city:this.citycode,
          country:this.country,
          formatid:this.formatid,
          life:this.life,
          listnum:this.listnum,
          proxyType:this.proxyType,
          state:this.state,
          uname:this.sonAccount,
          selectedMode:this.selectedMode,
          hostValue: this.hostValue,

        }
      ).then((res) => {
        if (res.data.code === 200) {
          this.ProxyContant = res.data.data.join('\n')
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
      });
    },
    copy(){
      var clipboard = new Clipboard('#equSN')
      clipboard.on('success', () => {
        this.$message.success('已成功复制到粘贴板')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.warning('该浏览器不支持复制')
        clipboard.destroy()
      })
    },
    downloadTxt() {
      let str = this.ProxyContant;
      let strData = new Blob([str], { type: 'text/plain;charset=utf-8' });
      saveAs(strData, 'ipipbright_'+ this.country +'.txt');
    },
  },
  beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.noticeTimer) {
      clearInterval(this.noticeTimer);
      this.noticeTimer = null;
    }
  },
};
</script>

<style scoped lang="less">
// 深色主题全局样式
.dark-theme {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%);
  color: #ffffff;
  min-height: 100vh;
}

// 公告栏样式
.announcement-banner {
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%);
  padding: 16px 0;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  margin: 20px;
}

.announcement-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.announcement-icon {
  color: #fbbf24;
  font-size: 20px;
}

.announcement-text {
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
}

// 主容器样式
.dashboard-container {
  padding: 0 20px 20px;
  // max-width: 1600px;
  margin: 0 auto;
}

// 概览卡片样式
.overview-card {
  background: rgba(30, 41, 59, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.overview-card:hover {
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
  transform: translateY(-2px);
}

.overview-header {
  margin-bottom: 24px;
}

.overview-title {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.overview-stats {
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-bottom: 32px;
}

.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-divider {
  width: 2px;
  background: rgba(255, 255, 255, 0.1);
}

.overview-progress {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

// 现代标签页样式
.modern-tabs {
  background: rgba(30, 41, 59, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  
  .ant-tabs-nav {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(59, 130, 246, 0.2);
  }
  
  .ant-tabs-tab {
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    font-weight: 500;
    padding: 12px 24px;
    margin: 0 8px;
    border-radius: 8px;
    transition: all 0.3s ease;
  }
  
  .ant-tabs-tab-active {
    color: #ffffff;
    background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%);
    box-shadow: 0 4px 16px rgba(21, 129, 198, 0.4);
  }
  
  .ant-tabs-ink-bar {
    background: transparent;
  }
  
  .ant-tabs-tab:hover {
    color: #1581c6;
    background: rgba(21, 129, 198, 0.1);
  }
}

// 标签页内容
.tab-content {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 24px;
  margin-top: 24px;
}

/* 确保所有标签页文字可见 - 使用:deep()穿透组件边界 */
:deep(.ant-tabs-tab),
:deep(.modern-tabs .ant-tabs-tab),
:deep(.ant-tabs-nav .ant-tabs-tab) {
  color: rgba(255, 255, 255, 0.9) !important;
  opacity: 1 !important;
  font-weight: 500 !important;
}

/* 确保选中标签页文字颜色 */
:deep(.ant-tabs-tab-active),
:deep(.modern-tabs .ant-tabs-tab-active) {
  color: #ffffff !important;
  opacity: 1 !important;
}

/* 确保标签页文字颜色 */
:deep(.ant-tabs-tab div) {
  color: rgba(255, 255, 255, 0.9) !important;
  opacity: 1 !important;
}

:deep(.ant-tabs-tab-active div) {
  color: #ffffff !important;
  opacity: 1 !important;
}

// 区域卡片通用样式
.section-card {
  background: rgba(30, 41, 59, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  color: #ffffff !important;
}

.section-card:hover {
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
  transform: translateY(-2px);
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(59, 130, 246, 0.2);
}

.card-icon {
  font-size: 20px;
  color: #1581c6;
  background: rgba(21, 129, 198, 0.1);
  padding: 8px;
  border-radius: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
}

// 代理信息样式
.proxy-details {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: 500;
}

.detail-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.detail-value {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff !important;
  background: rgba(21, 129, 198, 0.1);
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(21, 129, 198, 0.2);
}

// 确保所有卡片内文本为白色
.section-card * {
  color: inherit !important;
}

// 确保标签页文本颜色正确
.ant-tabs-tab {
  color: rgba(255, 255, 255, 0.8) !important;
}

.ant-tabs-tab-active {
  color: #ffffff !important;
}

.password-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.reset-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.reset-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

.copy-icon {
  color: #1581c6;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.copy-icon:hover {
  color: #1581c6;
  transform: scale(1.1);
}

/* 确保alert文字为白色，在深色主题下清晰可见 */
.detail-alert {
  margin-top: 8px;
  background: rgba(21, 129, 198, 0.1) !important;
  border: 1px solid rgba(21, 129, 198, 0.2) !important;
  color: #ffffff !important;
  border-radius: 8px;
}

/* 使用最高优先级的选择器覆盖默认样式 */
.ant-alert-info .ant-alert-message,
.detail-alert .ant-alert-message,
.section-card .ant-alert-message {
  color: #ffffff !important;
  font-size: 12px;
  opacity: 1 !important;
}

/* 确保所有alert的message都是白色 */
.ant-alert-message {
  color: #ffffff !important;
  opacity: 1 !important;
}

/* 确保alert组件的所有文本都是白色 */
.ant-alert-info,
.ant-alert-info * {
  color: #ffffff !important;
  opacity: 1 !important;
}

/* 确保section-card内的所有alert都是白色文字 */
.section-card .ant-alert {
  .ant-alert-message {
    color: #ffffff !important;
    opacity: 1 !important;
  }
}

/* 使用:deep()穿透组件，确保覆盖默认样式 */
:deep(.ant-alert-message) {
  color: #ffffff !important;
  opacity: 1 !important;
}

/* 确保所有alert组件的message都是白色 */
:deep(.ant-alert-info .ant-alert-message),
:deep(.detail-alert .ant-alert-message) {
  color: #ffffff !important;
  opacity: 1 !important;
  font-size: 12px !important;
}

// 配置网格样式
.config-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
}

.config-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.config-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.config-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

// 选择器样式 - 确保所有文本可见
.ant-select {
  width: 100% !important;
  color: #ffffff !important;
}

/* 直接针对选择器的所有文本元素 - 最高优先级 */
.ant-select,
.ant-select *,
.ant-select .ant-select-selector,
.ant-select .ant-select-selector *,
.ant-select .ant-select-selection-placeholder,
.ant-select .ant-select-selection-item,
.ant-select .ant-select-selection-selected-value,
.ant-select .ant-select-selection__rendered,
.ant-select .ant-select-selection__rendered > div,
.ant-select-dropdown,
.ant-select-dropdown *,
.ant-select-dropdown-menu,
.ant-select-dropdown-menu-item,
.ant-select-dropdown-menu-item * {
  color: #ffffff !important;
  opacity: 1 !important;
}

/* 使用:deep()确保选择器内所有文字为白色 */
:deep(.ant-select-selection-placeholder),
:deep(.ant-select-selection-item),
:deep(.ant-select-selection-selected-value),
:deep(.ant-select-selection__rendered),
:deep(.ant-select-selection__rendered > div),
:deep(.ant-select-search__field),
:deep(.ant-select-dropdown-menu-item),
:deep(.ant-select-dropdown-menu-item *),
:deep(.ant-select-arrow) {
  color: #ffffff !important;
  opacity: 1 !important;
  font-weight: 500 !important;
}

/* 确保选择器内文字为白色 - 覆盖所有可能的样式 */
.ant-select-selection-placeholder,
.ant-select-selection-item,
.ant-select-selection-selected-value,
.ant-select-selection__rendered,
.ant-select-selection__rendered > div {
  color: #ffffff !important;
  opacity: 1 !important;
  font-weight: 500 !important;
}

/* 选择器输入框样式 - 黑色背景白色文字，统一深色主题 - 最高优先级 */
.ant-select .ant-select-selector,
.ant-select-selection,
.ant-select-selection--single,
.ant-select-selection__rendered {
  background: rgba(30, 41, 59, 0.9) !important;
  border: 1px solid rgba(59, 130, 246, 0.5) !important;
  border-radius: 8px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  color: #ffffff !important;
}

/* 确保选择器背景为黑色，覆盖所有可能的样式 */
:deep(.ant-select-selector),
:deep(.ant-select-selection),
:deep(.ant-select-selection--single),
:deep(.ant-select-selection__rendered) {
  background: rgba(30, 41, 59, 0.9) !important;
  // border: 1px solid rgba(59, 130, 246, 0.5) !important;
  color: #ffffff !important;
}

/* 确保所有选择器相关元素背景为黑色 */
.ant-select-dropdown,
.ant-select-dropdown-menu,
.ant-select-dropdown-menu-item,
.ant-select-dropdown * {
  background: rgba(30, 41, 59, 0.95) !important;
  color: #ffffff !important;
}

/* 确保选择器搜索框背景为黑色 */
.ant-select-search__field,
:deep(.ant-select-search__field) {
  background: rgba(30, 41, 59, 0.9) !important;
  color: #ffffff !important;
  border: 1px solid rgba(59, 130, 246, 0.5) !important;
}

/* 确保选择器搜索框占位符为白色 */
.ant-select-search__field::placeholder,
:deep(.ant-select-search__field::placeholder) {
  color: rgba(255, 255, 255, 0.4) !important;
}

/* 确保选中值可见 - 白色文字 */
.ant-select .ant-select-selection-selected-value,
.ant-select-selection-selected-value,
:deep(.ant-select-selection-selected-value) {
  color: #ffffff !important;
  opacity: 1 !important;
  display: block !important;
  font-weight: 600 !important;
}

/* 确保渲染区域可见 - 白色文字 */
.ant-select .ant-select-selection__rendered,
.ant-select-selection__rendered,
:deep(.ant-select-selection__rendered) {
  color: #ffffff !important;
  opacity: 1 !important;
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  background: transparent !important;
}

/* 下拉菜单样式 - 黑色背景白色文字，统一深色主题 */
.ant-select-dropdown,
:deep(.ant-select-dropdown) {
  background: rgba(30, 41, 59, 0.95) !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4) !important;
}

.ant-select-dropdown-menu,
:deep(.ant-select-dropdown-menu) {
  background: transparent !important;
}

.ant-select-dropdown-menu-item,
:deep(.ant-select-dropdown-menu-item) {
  color: #ffffff !important;
  background: transparent !important;
  padding: 8px 16px !important;
  margin: 0 !important;
  border-radius: 4px !important;
  transition: all 0.2s ease !important;
}

.ant-select-dropdown-menu-item:hover,
.ant-select-dropdown-menu-item-active,
:deep(.ant-select-dropdown-menu-item:hover),
:deep(.ant-select-dropdown-menu-item-active) {
  background: rgba(21, 129, 198, 0.2) !important;
  color: #ffffff !important;
}

.ant-select-dropdown-menu-item-selected,
:deep(.ant-select-dropdown-menu-item-selected) {
  background: rgba(21, 129, 198, 0.3) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* 确保下拉菜单分隔线为深色 */
.ant-select-dropdown-menu-item-divider,
:deep(.ant-select-dropdown-menu-item-divider) {
  background: rgba(255, 255, 255, 0.1) !important;
  margin: 4px 0 !important;
}

/* 确保选择器箭头为白色 */
.ant-select-arrow,
:deep(.ant-select-arrow) {
  color: rgba(255, 255, 255, 0.6) !important;
  opacity: 1 !important;
}

/* 确保搜索无结果时文字为白色 */
.ant-select-dropdown-menu-empty,
:deep(.ant-select-dropdown-menu-empty) {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* 主机选择器特定样式 */
.host-select {
  .ant-select-selector {
    color: #ffffff !important;
    background: rgba(51, 65, 85, 0.9) !important;
  }
  
  .ant-select-selection-selected-value {
    color: #ffffff !important;
    opacity: 1 !important;
    font-weight: 600 !important;
    font-size: 14px !important;
  }
}

/* 修复ant-design-vue的样式覆盖问题 */
:deep(.ant-select-selection-selected-value) {
  color: #ffffff !important;
  opacity: 1 !important;
}

:deep(.ant-select-selection__rendered) {
  color: #ffffff !important;
  opacity: 1 !important;
}

:deep(.ant-select-selection-placeholder) {
  color: rgba(255, 255, 255, 0.6) !important;
}

// 生成器操作区样式
.generator-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding: 20px;
  background: rgba(21, 129, 198, 0.05);
  border: 1px solid rgba(21, 129, 198, 0.2);
  border-radius: 12px;
}

.generate-button {
  background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%) !important;
  border: none !important;
  padding: 6px 32px !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  transition: all 0.3s ease !important;
  box-sizing: content-box;
}

.generate-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(21, 129, 198, 0.5) !important;
}

.generate-button span {
  color: #ffffff !important;
}

.secondary-actions {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.action-btn {
  background: rgba(51, 65, 85, 0.8) !important;
  border: 1px solid rgba(59, 130, 246, 0.3) !important;
  color: #ffffff !important;
  padding: 6px 20px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
  box-sizing: content-box;
}

.action-btn:hover {
  background: rgba(21, 129, 198, 0.2) !important;
  border-color: #1581c6 !important;
  transform: translateY(-1px) !important;
}

.action-btn span,
.action-btn .anticon {
  color: #ffffff !important;
}

// 重置按钮样式
.reset-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  border: none !important;
  padding: 6px 16px !important;
  border-radius: 8px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  transition: all 0.3s ease !important;
}

.reset-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4) !important;
}

.reset-btn span {
  color: #ffffff !important;
}

// 所有输入元素的黑色主题样式
.ant-input,
.ant-input-number,
.ant-select-selector,
.ant-input-textarea,
.proxy-result,
.ant-cascader-picker,
.ant-time-picker,
.ant-date-picker,
.ant-rate,
.ant-slider {
  background: rgba(30, 41, 59, 0.9) !important;
  border: 1px solid rgba(59, 130, 246, 0.5) !important;
  color: #ffffff !important;
}

/* 确保所有输入文本为白色 */
.ant-input,
.ant-input-number,
.ant-select-selection-item,
.ant-select-selection-selected-value,
.ant-input-textarea,
.ant-input-textarea > textarea,
.proxy-result .ant-input,
.ant-cascader-picker,
.ant-time-picker,
.ant-date-picker {
  color: #ffffff !important;
}

/* 占位符样式 */
.ant-input::placeholder,
.ant-input-number::placeholder,
.ant-select-selection-placeholder,
.ant-input-textarea::placeholder,
.ant-input-textarea > textarea::placeholder,
.ant-cascader-picker::placeholder,
.ant-time-picker::placeholder,
.ant-date-picker::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

/* 代理结果文本框 */
.proxy-result {
  background: rgba(30, 41, 59, 0.9) !important;
  border: 1px solid rgba(59, 130, 246, 0.5) !important;
  border-radius: 8px !important;
  color: #ffffff !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  font-size: 13px !important;
  line-height: 1.6 !important;
}

.proxy-result .ant-input,
:deep(.proxy-result .ant-input) {
  background: transparent !important;
  color: #ffffff !important;
}

.proxy-result .ant-input::placeholder,
:deep(.proxy-result .ant-input::placeholder) {
  color: rgba(255, 255, 255, 0.4) !important;
}

/* 确保textarea内文字为白色 */
:deep(.ant-input-textarea),
:deep(.ant-input-textarea textarea) {
  color: #ffffff !important;
  background: rgba(30, 41, 59, 0.9) !important;
  border: 1px solid rgba(59, 130, 246, 0.5) !important;
}

/* 输入框聚焦状态 */
.ant-input:focus,
.ant-input-number:focus,
.ant-select-selector:focus,
.ant-input-textarea:focus,
.ant-input-textarea > textarea:focus,
.ant-cascader-picker:focus,
.ant-time-picker:focus,
.ant-date-picker:focus {
  border-color: #1581c6 !important;
  box-shadow: 0 0 0 2px rgba(21, 129, 198, 0.2) !important;
}

/* 静态代理区域的输入元素 */
.static-proxy-section .ant-select-selector {
  background: rgba(30, 41, 59, 0.9) !important;
  border: 1px solid rgba(59, 130, 246, 0.5) !important;
  color: #ffffff !important;
}

.static-proxy-section .ant-select-selection-item,
.static-proxy-section .ant-select-selection-selected-value {
  color: #ffffff !important;
}

// 静态代理表格
.static-proxy-section {
  margin-top: 24px;
}

.static-filter {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px;
  background: rgba(21, 129, 198, 0.05);
  border: 1px solid rgba(21, 129, 198, 0.2);
  border-radius: 12px;
}

.static-table {
  background: rgba(30, 41, 59, 0.8) !important;
  border: 1px solid rgba(59, 130, 246, 0.2) !important;
  border-radius: 12px !important;
  overflow: hidden;
  
  .ant-table-thead > tr > th {
    background: rgba(51, 65, 85, 0.8) !important;
    border-bottom: 1px solid rgba(59, 130, 246, 0.2) !important;
    color: rgba(255, 255, 255, 0.8) !important;
    font-weight: 700 !important;
    font-size: 14px;
  }
  
  .ant-table-tbody > tr {
    background: transparent !important;
    border-bottom: 1px solid rgba(59, 130, 246, 0.1) !important;
  }
  
  .ant-table-tbody > tr > td {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 14px;
  }
  
  .ant-table-tbody > tr:hover > td {
    background: rgba(21, 129, 198, 0.1) !important;
  }
  
  .ant-pagination {
    color: rgba(255, 255, 255, 0.6) !important;
  }
  
  .ant-pagination-item {
    background: rgba(51, 65, 85, 0.8) !important;
    border: 1px solid rgba(59, 130, 246, 0.3) !important;
  }
  
  .ant-pagination-item a {
    color: rgba(255, 255, 255, 0.6) !important;
  }
  
  .ant-pagination-item-active {
    background: linear-gradient(135deg, #1581c6 0%, #1581c6 100%) !important;
    border-color: transparent !important;
  }
  
  .ant-pagination-item-active a {
    color: #ffffff !important;
  }
  
  .ant-pagination-prev button,
  .ant-pagination-next button {
    background: rgba(51, 65, 85, 0.8) !important;
    border: 1px solid rgba(59, 130, 246, 0.3) !important;
    color: rgba(255, 255, 255, 0.6) !important;
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .tab-content {
    grid-template-columns: 1fr;
  }
  
  .config-group {
    grid-template-columns: 1fr;
  }
  
  .generator-actions {
    flex-direction: column;
    align-items: stretch;
  }
  
  .secondary-actions {
    margin-left: 0;
    justify-content: stretch;
  }
  
  .overview-stats {
    flex-direction: column;
    gap: 24px;
  }
  
  .stat-divider {
    width: 100%;
    height: 2px;
  }
}

@media (max-width: 768px) {
  .dashboard-container {
    padding: 0 16px 16px;
  }
  
  .overview-card {
    padding: 20px;
  }
  
  .section-card {
    padding: 20px;
  }
  
  .modern-tabs {
    padding: 16px;
  }
  
  .announcement-banner {
    margin: 16px;
  }
  
  .overview-stats {
    flex-direction: column;
    gap: 20px;
  }
  
  .static-filter {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>